import template from "./stop_scheduling.html";
import controller from "./stop_scheduling.controller";
import "./stop_scheduling.scss";

let branchManagementStopSchedulingComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementStopSchedulingComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/stop_scheduling/stop_scheduling.component.js